<template>
	<section class='leaveStu'>
		<Row>
			<Breadcrumb>
				<BreadcrumbItem to="">食堂消费</BreadcrumbItem>
				<BreadcrumbItem to="">入部审核</BreadcrumbItem>
			</Breadcrumb>
		</Row>
		<Row xs="20" sm="16" md="12" lg="8">

			<Col span='4'>
				<Input v-model="searchParam.name" placeholder="" />
			</Col>

			<Col span='4'>
				<Button type="info" @click='searchData'>查询</Button>
        
			</Col>
      
		</Row>
  
    <div  style='display:flex;justify-content:space-between;margin-top:20px;'>
      <div id='pdData' class='pdData'  >
        <div :class='[0 == curIndex ? "active" : ""]' class='itempd'   @click='tabPD(0)'>待审核</div>
        <div :class='[2 == curIndex ? "active" : ""]' class='itempd'   @click='tabPD(2)'>已拒绝</div>
      </div>
      
          
		</div>
   
		<section class='tabelContent'>
			<tablePage border :queryData="queryData" :searchParam='searchParam' :issearch='issearch'></tablePage>
		</section>


	

   
	</section>
</template>

<script>
	import getDates from '../utils/index'
	import tablePage from './tablePage'
	import bemodal from './formItem'
  import utils from '../utils/index'
	export default {
		name: 'noticelist',
		components: {
			tablePage,
			bemodal,
		},
		data() {
			return {
       
        editDepart:false,
        changeDepartid:'',
        changeDepartUserid:'',
        edituser:false,
        departlist:[],
        curIndex:0,
				formItem:{
					name:'',
					amount:0,
					schoolid:-1,
					userid:-1,
          departid:'',
          remark:'',
          flag:'teach',
				},
				addMoney:false,
				hisData:'',
				columnshis:[],
				showhis:false,
				showpay:false,
				smodal: false,
				reloadTmep: -1,
				initformData:[],
				queryData: ['appUser/dataList?nickstate=-1&departstatus=0&departid=-1',
					[{
							title: '姓名',
							key: '',
							width: 200,
							ellipsis:true,
							render:(h,params) =>{
								var pic = params.row.imgurl?params.row.imgurl:''
                	var _firstLetter = ''
                if(params.row.name){
                  _firstLetter = params.row.name.substr(0, 1)
                }
                var _zd = {
                      style: {
                        color: "#ed4c78",
                        backgroundColor: "rgba(237,76,120,.1)",
                        padding:"2px 8px",
                        borderRadius:'7px',
                        fontSize:'11px',
                        display:'inline-block',
                        marginRight:'4px',
                      }
                     }
                var _isno = ''
                if(params.row.state == 1){
                  _isno =  h('span',_zd, '已禁用')
                }
								if(pic){
									return h('viewer',[
												h('img', {
														style: {//设置样式
															display:'inline-block',
															width:'30px',
															height:'30px',
															borderRadius:'50%',
															textAlign:'center',
															lineHeight:'30px',
															position:'absolute',
														},
														attrs: {//设置属性
															src: pic
														}
												}),
												h('span',{
													style: {
                              fontWeight:'bold',
                              width:'30px',
                              height:'30px',
                              paddingLeft:'45px',
                              lineHeight:'30px',
													},
												},params.row.name || ''),
                        _isno
											]
										)
								}else{
									return  h('div',[
												h('span', {

													style: {
                              display:'inline-block',
                              width:'30px',
                              height:'30px',
                              background:'rgba(237,76,120,.1)',
                              borderRadius:'50%',
                              textAlign:'center',
                              lineHeight:'30px',
                              color:'#ed4c78',
                              position:'absolute',

													},
												}, _firstLetter),
												h('span',{
													style: {
														fontWeight:'bold',
														width:'30px',
														height:'30px',
														paddingLeft:'45px',
														lineHeight:'30px',
													},
												},params.row.name),
                          _isno
												])
								}
							}
						},
            {
            	title: '申请部门',
            	key: 'departname',
            	align: 'center',
            },
            {
            	title: '手机号码',
            	key: 'phone',
            	align: 'center',
            },
            {
							title: '操作',
							slot: 'action',
							width: 200,
							align: 'center',
							render:(h,params)=>{
                var isrefuse  = this.curIndex == 0
                if(this.curIndex == 0){
                  return  h('div',[
											h('span', {
												style: {
													display:'inline-block',
													width:'60px',
													height:'25px',
													background:'#e22a1c',
													borderRadius:'6px',
													textAlign:'center',
													lineHeight:'25px',
													color:'#fff',
													fontSize:'12px',
													cursor:'pointer',
													userSelect:'none',
                          marginRight:'10px'
												},
												on: {
													click: () => {
                            var rows = params.row 
                            var that = this 
                            var param = {
                               state:2,
                               guid:rows.guid,
                               unionid:rows.unionid
                            }
                           
                            this.axios.post('appUser/updateDepartState',param).then( res=> {
                              if(res.success){
                                that.$Message.info(res.msg)
                                that.searchData()
                               
                              }else{
                                that.$Message.error(res.msg)
                              }
                            })
                           
                          
													
													}
												}
											}, '拒绝'),
                      h('span', {
												style: {
													display:'inline-block',
													width:'60px',
													height:'25px',
													background:'#2db7f5',
													borderRadius:'6px',
													textAlign:'center',
													lineHeight:'25px',
													color:'#fff',
													fontSize:'12px',
													cursor:'pointer',
													userSelect:'none'
												},
												on: {
													click: () => {

                            var rows = params.row 
                            var that = this 
                            var param = {
                               state:1,
                               guid:rows.guid,
                               unionid:rows.unionid
                            }
                           
                            this.axios.post('appUser/updateDepartState',param).then( res=> {
                              if(res.success){
                                that.$Message.info(res.msg)
                                that.searchData()
                               
                              }else{
                                that.$Message.error(res.msg)
                              }
                            })
                           

													}
												}
											}, '通过')
									])
                }else{
                  return  h('div',[
                      h('span', {
												style: {
													display:'inline-block',
													width:'60px',
													height:'25px',
													background:'#2db7f5',
													borderRadius:'6px',
													textAlign:'center',
													lineHeight:'25px',
													color:'#fff',
													fontSize:'12px',
													cursor:'pointer',
													userSelect:'none'
												},
												on: {
													click: () => {

                            var rows = params.row 
                            var that = this 
                            var param = {
                               state:1,
                               guid:rows.guid,
                               unionid:rows.unionid
                            }
                           
                            this.axios.post('appUser/updateDepartState',param).then( res=> {
                              if(res.success){
                                that.$Message.info(res.msg)
                                that.searchData()
                               
                              }else{
                                that.$Message.error(res.msg)
                              }
                            })
                           

													}
												}
											}, '通过')
									])
                }
							
								// <span class='do' @click="show(index,row)">编辑</span>
							}
            },
					]
				],
				searchParam: {
					name:'',
				},
				issearch: -1,
				isshowpay: -1,
				isshowhis: -1,
				userInfo:{},
        curGuid:'',
			}
		},
		mounted(){

			this.userInfo = JSON.parse(localStorage.getItem('inchUserinfo'))
     
      
		},
		methods: {
      tabPD(index){
        console.log(index)
        var that = this 
        this.curIndex = index 
       
        that.queryData[0] = 'appUser/dataList?nickstate=-1&departstatus='+index+'&departid=-1'
        that.searchData()
      },
      changeDepart(){
        this.editDepart = true
      },
      changeDepartMethod(){
        console.log(this.changeDepartid)
        var that = this
        var param = {
            departid:this.changeDepartid,
            guid:this.changeDepartUserid,

        }
        
      
          this.axios.post('appUser/changeDepart',param).then( res=> {
            if(res.success){
              that.$Message.info(res.msg)
              that.reloadTable()
              that.editDepart = false
            }else{
              that.$Message.error(res.msg)
            }
          })
      },
      postNews(){
        var that = this
        var param = {
            state:this.formItem.state,
            guid:this.formItem.guid,

        }
        //console.log(param,'parm')

          this.axios.post('appUser/save',param).then( res=> {
            if(res.success){
              that.$Message.info(res.msg)
              that.reloadTable()
              that.edituser = false
            }else{
              that.$Message.error(res.msg)
            }
          })
      },
			updateLesson(){
				console.log(this.formItem)
				var that = this
				if(this.formItem.amount!=0){

					this.axios.post('canteenAmountRecord/save',this.formItem).then((a) =>{
						if(a.success){
							that.$Message.info(a.msg)
							that.issearch = Math.random()
							that.formItem = {
								name:'',
                remark:'',
                departid:'',
								amount:0,
								schoolid:-1,
								userid:-1,
							}
						}
					})
				}

			},
      removeItem(){
          var that = this
          this.$Modal.confirm({
                title: '提示',
                content: '<p>是否确认删除？</p>',
                onOk: () => {
                  //console.log(that.curStuInfo)
                    var param = {
                      id:that.curStuInfo.guid
                    }

                    that.axios.post('appUser/delete.do',param).then(res=>{
                      if(res.success){
                      	that.$Message.info(res.msg)
                      	that.reloadTable()
                      	that.edituser = false
                      }else{
                      	that.$Message.error(res.msg)
                      }
                    })
                },
                onCancel: () => {

                }
            });
      },
      exportData() {
        // student/exportNoFace
        
        var tHeader = ["姓名","所属部门","手机号","账户余额（元）"]
        var filterVal = ['name', 'departname','phone', 'amount']
       
        utils.exportExcel('appUser/dataList?nickstate=-1&departstatus=0&departid=-1', {},this.curItem['name'], tHeader, filterVal)
      },
      getDepart(){
      
        var that = this
			
      
        this.axios.get('dic/getQueryList',{params:{rootid:'depart',length:-1}}).then((a) =>{
          console.log(a,'a')
          that.curItem = a['data'][0]
          that.departlist = a.data
          that.queryData[0] = 'appUser/dataList?nickstate=-1&departstatus=0&departid=-1'
          that.searchData()
        })
				
      },
      getId(id){
        var that = this
        this.formItem ={
          state:'0',
          isadmin:'0',
          guid:'',
        }
        this.lanmu = []
        this.mewsto = []
        this.edituser = true
        that.treekey = Math.random()
        if(id!=-1){
          this.isnewModal = false
        	this.axios.get('appUser/getId.do',{params:{guid:id}}).then( res=> {
        		//console.log(res)
            that.formItem.state = String(res.data.state)
           
            that.formItem.guid =res.data.guid
        	})
        }

      },
  
			getHisData(name,row){
				this.showhis = true
				this.isshowhis = Math.random()
				var url = this.columnshis[0].split("?")[0]
				this.columnshis[0] = url+'?name='+name
			},
			getPayData(name,row){
        console.log(row,'row')
				this.showpay = true
				this.isshowpay = Math.random()
				var url = this.payhis[0].split("?")[0]
				// this.payhis[0] = url+'?name='+name
        this.payhis[0] = url+'?userid='+row.guid
			},
			searchData() {
				this.issearch = Math.random()
			},
			reloadTable() {
				this.issearch = Math.random()
			},
		}
	}
</script>

<style scoped>
	.tabelContent {
		margin-top: 20px;
	}
	.leaveStu{
		flex:1;
		padding-right:25px!important;
		/* overflow: scroll; */
		padding-bottom:50px;
		padding-top:20px;
		overflow-x:hidden;
	}
	.leaveStu .ivu-row:first-of-type {
		margin-top: 5px;
	}

	.leaveStu .ivu-row {
		margin-top: 20px;
		/* 	overflow:hidden; */
		position: relative;
	}

	.leaveStu .ivu-col {
		margin-right: 10px;
		/* float:left; */
	}

	.leaveStu .ivu-col:last-of-type {
		float: left;
		margin-left: 0px;
		/* position:absolute;
		right:0px; */
	}

	.demo-upload-list {



		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		overflow: hidden;
		margin-right: 4px;
		margin-bottom: 5px;
	}

	.demo-upload-list img {
		width: 40px;
		height: 40px;
		float: left;
		margin-right: 15px;
	}

	.demo-upload-list span {
		line-height: 40px;
		font-size: 12px;
		float: left;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 10px;
		line-height: 40px;

	}

	#hwSchool {
		position: relative;
	}

	#hwSchool .ivu-tree {
		position: absolute;
		top: 33px;
		left: 0px;
		background: #fff;
		z-index: 1000;
		width: 300px;
		height: 300px;
		border: 1px solid #dcdee2;
		border-top: 0 none;
		overflow-y: scroll;
		overflow-x: hidden;
		padding-left: 10px;
	}

	.modalUl {
		width: 100%;
		display: flex;
		justify-content: space-between;


	}

	.modalUl li {
		list-style: none;

	}

	.modalUl>li:first-of-type {
		width: 35%;
		height: 100%;
		height: 400px;
		overflow-y: scroll;
		overflow-x: hidden;
	}

	.modalUl>li:last-of-type {
		flex: 1;
		padding-left: 30px;
	}

	.treeContent {}

	.hwImgCon {
		margin-top: 10px;

	}

	.hwImgCon img {
		width: 55px;
		height: 55px;
		border-radius: 5px;
	}

	.conheadRight {
	  align-items:right
	}
  .pdData {
    display: flex;
    justify-content: flex-start;
    list-style:none;
    flex-wrap: wrap;
  }
  .itempd {
    height: 32px;
    line-height: 32px;
    border-radius: 20px;
    padding: 0 15px;
    font-size: 14px;
    margin-right: 10px;
    cursor: pointer
  }

  .itempd.active {
    background-color: #00d186;
    border-color: #00d186;
    color: #fff;
  }
  .remove{
    float:left;
  }
  .pdData {
    display: flex;
    justify-content: flex-start;
    list-style:none;
    flex-wrap: wrap;
  }
  .itempd {
    height: 32px;
    line-height: 32px;
    border-radius: 20px;
    padding: 0 15px;
    font-size: 14px;
    margin-right: 10px;
    cursor: pointer
  }

  .itempd.active {
    background-color: #00d186;
    border-color: #00d186;
    color: #fff;
  }
</style>
